// Light/dark theme: system-following (prefers-color-scheme) by default, with
// a persisted manual override. The 'tym-theme' localStorage key is also read
// by an inline script in index.html so the correct theme applies before
// first paint (no flash) — keep both in sync if this key ever changes.
const KEY = 'tym-theme';
type Pref = 'light' | 'dark' | null; // null = follow system

function readPref(): Pref {
  const v = localStorage.getItem(KEY);
  return v === 'light' || v === 'dark' ? v : null;
}

function apply(dark: boolean) {
  document.documentElement.classList.toggle('dark', dark);
}

const media = window.matchMedia('(prefers-color-scheme: dark)');

class ThemeState {
  pref = $state<Pref>(readPref());
  isDark = $derived(this.pref ? this.pref === 'dark' : media.matches);

  constructor() {
    // Only react to system changes while the user hasn't set an explicit preference.
    media.addEventListener('change', (e) => {
      if (this.pref === null) apply(e.matches);
    });
  }

  toggle() {
    this.pref = this.isDark ? 'light' : 'dark';
    localStorage.setItem(KEY, this.pref);
    apply(this.pref === 'dark');
  }

  useSystem() {
    this.pref = null;
    localStorage.removeItem(KEY);
    apply(media.matches);
  }
}

export const theme = new ThemeState();
